<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Clear manual rates</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <p v-if="rates.length > 0">
                Are you sure you want to convert {{ rates.length }} manuals
                rates to automatic?
              </p>
              <p v-else>
                No manual rates found on this page
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="close">
          Cancel
        </v-btn>
        <v-btn
          v-if="rates.length > 0"
          color="error"
          :loading="loading"
          :disabled="loading"
          @click="clearRates"
        >
          Clear
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ClearManualRatesModal",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    rates: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    clearRates() {
      this.loading = true;
      this.$store
        .dispatch("RecordStore/clearManualRates", { corridors: this.rates })
        .then(() => {
          this.$emit("clear");
          this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
